import { useMemo } from 'react';
import type { BrandingState } from '@/hooks/chat/brandingState';
import { getAccessToken } from '@/services/api';
import { resolveInstanceAppConfig } from './instanceAppConfig';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/** Refresh credentials at the existing fetch boundary, without recreating the Host/Controller. */
const fetchAuthenticated: typeof fetch = (input, init) => {
  const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
  const token = getAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  else headers.delete('Authorization');
  return globalThis.fetch(input, { ...init, headers, credentials: 'include' });
};

/** Share input assembly; each page still owns its existing project-selection policy. */
export const usePageConfig = ({ branding, projectId, defaultProjectName, functionType, defaultSessionTitle }: {
  branding: BrandingState; projectId: string; defaultProjectName: string;
  functionType: string; defaultSessionTitle: string;
}) => {
  return useMemo(() => {
    const defaults = { apiBaseUrl: API_BASE_URL, backendMode: 'real', defaultProjectName,
      defaultSessionTitle, domainPackDomain: branding.domainPackDomain, domainPackVersion: branding.domainPackVersion,
      functionType, instanceId: branding.instanceId, projectId, userId: branding.userId };
    return { ...resolveInstanceAppConfig({ defaults }), ...defaults, apiToken: '', fetchImpl: fetchAuthenticated,
      branding: branding.branding, capabilityCatalog: branding.capabilityCatalog,
      composerModeOptions: branding.composerModeOptions, displayPolicy: branding.displayPolicy,
      instanceProfile: branding.instanceProfile, modulePromptRegistry: branding.modulePromptRegistry,
      productName: branding.uiLabels.product_name, productTag: branding.uiLabels.brand_tag,
      starterScenarios: branding.starterPrompts, uiLabels: branding.uiLabels };
  }, [branding, defaultProjectName, defaultSessionTitle, functionType, projectId]);
};
